import { fetchAPI } from "./backendClient";

/**
 * Tax code explanation response from the API.
 */
export interface TaxCodeExplanation {
  is_valid: boolean;
  summary: string;
  details: string[];
  personal_allowance: string | null;
  region: 'england' | 'scotland' | 'wales' | null;
  warnings: string[];
  error: string | null;
}

/**
 * Tax code warning from payslip validation.
 */
export interface TaxCodeWarning {
  type: string;
  message: string;
  severity: 'info' | 'warning' | 'error';
}

/**
 * Fetch explanation for a UK tax code.
 *
 * @param code - Tax code to explain (e.g., "1257L", "S1257L", "BR")
 * @returns Promise resolving to TaxCodeExplanation
 */
export async function explainTaxCode(code: string): Promise<TaxCodeExplanation> {
  const encodedCode = encodeURIComponent(code);
  const resp = await fetchAPI(`/v1/tax-code/${encodedCode}/`);

  if (!resp.ok) {
    const errorData = await resp.json().catch(() => ({}));
    const message = errorData?.error || errorData?.detail || `HTTP ${resp.status}`;
    throw new Error(message);
  }

  return resp.json();
}
